export default "__VITE_ASSET__BebKO2il__"